import React, { useCallback, useState } from 'react';
import { cn } from '@bem-react/classname';
import { AppCheckbox, AppFontIcon, AppText } from '@frontend-modules/ui-kit';
import { E_COLORS } from 'src-new/constants';

import { ITaskViewProps } from './TaskView.types';

import './TaskView.scss';

const CnClassTaskView = cn('task-view');

export const TaskView: React.FC<ITaskViewProps> = ({
    title,
    isSelected,
    isTemplate = false,
    isPosted = false,
    canRepeatTask = false,
    isForMethodist = false,
    handleSelect,
    onTitleClick,
    withCheckbox = true,
    disabledSelect,
    handleDeleteButtonClick,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseLeave = useCallback(() => {
        setIsHovered(false);
    }, []);

    const handleMouseEnter = useCallback(() => {
        setIsHovered(true);
    }, []);
    return (
        <div
            className={CnClassTaskView('wrapper', { disabledSelect })}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className={CnClassTaskView()}>
                {withCheckbox && (
                    <AppCheckbox
                        onChange={handleSelect}
                        defaultValue={isSelected}
                        disabled={isPosted && !canRepeatTask}
                    />
                )}
                <AppFontIcon
                    icon={isTemplate ? 'homework-shb-l' : 'homework-l'}
                    color={isSelected ? E_COLORS.firm_blue_color : E_COLORS.dark_grey_color_4}
                />

                <div className={CnClassTaskView('main')} onClick={onTitleClick} title={title}>
                    <AppText text={title} textStyle={'DesktopH6'} />
                </div>
            </div>
            {isHovered && (
                <div className={CnClassTaskView('buttons-block')}>
                    {(!isTemplate || isForMethodist) && !isPosted && (
                        <AppFontIcon icon={'delete-l'} color={E_COLORS.coral_color} onClick={handleDeleteButtonClick} />
                    )}
                </div>
            )}
        </div>
    );
};
